export const environment = {
  production: true,

  baseUrl: 'https://api.ilcorsaronero.it:3005',

  api:{
    userLogin: '/users/authenticate',
    articles: '/articles',
    articlesBody: '/articlesBody',
    articlesLatest: '/lastArticles',
    articlesByCategory: '/articlesByCategory',
    guides: '/guides',
    guidesBody: '/guidesBody',
  }
};
